import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CHAT_EXTERNAL_TYPE, LOGISTIC_TYPES } from '../enum/constants';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IParams } from '../model/http';

export const initItemsTgParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export interface logisticBody {
  logistic_type: LOGISTIC_TYPES;
  chat_type: CHAT_EXTERNAL_TYPE;
  ttn: any;
  chat_uuid: string;
  phone?: any;
  is_check: boolean;
}

export interface checkBindsBody {
  chat_uuid: string;
}

@Injectable({
  providedIn: 'root'
})

export class LogisticService {
  constructor(
    private readonly http: HttpClient
  ) { }

  private readonly itemsTgSubject$ = new BehaviorSubject<any>({});
  public readonly itemsTg$ = this.itemsTgSubject$.asObservable();
  public readonly isLoader$ = new BehaviorSubject<boolean>(false);

  public queryItemsTgParams = { ...initItemsTgParams };


  syncLogistic(payload: logisticBody) {
    return this.http.post(environment.baseURL + '/logistic', payload);
  }

  checkBinds(payload: checkBindsBody) {
    return this.http.post(environment.baseURL + '/logistic/sync', payload);
  }

  checkBindsCount(payload: checkBindsBody) {
    return this.http.post<{data: Record<string, number>}>(environment.baseURL + '/logistic/count', payload)
      .pipe(map(res => res.data));
  }

  private getItemsTg(params: any) {
    return this.http.get<any>(environment.baseURL + '/logistic/telegram', { params })
      .pipe(map(v => v.data));
  }

  loadItemsTg() {
    this.isLoader$.next(true);
    return this.getItemsTg(this.queryItemsTgParams)
      .pipe(tap((users) => {
        this.itemsTgSubject$.next(users);
        this.isLoader$.next(false);
      }));
  }

  setQueryItemsTgParams(params: IParams) {
    const { sort, order, search, take, page } = params;
    this.queryItemsTgParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryItemsTgParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryItemsTgParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryItemsTgParams.search,
      take: take || this.queryItemsTgParams.take,
      page: page || this.queryItemsTgParams.page,
    };
    return this.loadItemsTg();
  }

  addPhoneIntegration(phone: string) {
    const payload = {
      phone,
    };
    return this.http.post<{data: Record<string, number>}>(environment.baseURL + '/logistic/telegram', payload)
      .pipe(map(res => res.data));
  }
  removePhoneIntegration(uuid: string) {
    return this.http.delete<{data: Record<string, number>}>(environment.baseURL + `/logistic/telegram/${uuid}`)
      .pipe(map(res => res.data));
  }
}
